import React from "react";
import { Container } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import "./footer.css";

const socials = [
  {
    href: "https://github.com/shankarkharel",
    label: "github",
    icon: <AiFillGithub />,
  },
  {
    href: "https://twitter.com/shankarkharel19",
    label: "twitter",
    icon: <AiOutlineTwitter />,
  },
  {
    href: "mailto:itsshankar35@gmail.com",
    label: "email",
    icon: <AiOutlineMail />,
  },
  {
    href: "https://www.linkedin.com/in/shankar-kharel-162846168/",
    label: "linkedin",
    icon: <FaLinkedinIn />,
  },
  {
    href: "https://www.instagram.com/shankarkharel07",
    label: "instagram",
    icon: <AiFillInstagram />,
  },
];

function Footer() {
  return (
    <Container fluid className="footer">
      <Container className="footer-shell">
        <div className="footer-copywright">
          <span className="footer-label">Shankar Kharel</span>
          <p>
            Backend Engineer based in Balkumari, Lalitpur, Nepal.
          </p>
        </div>
        <ul className="footer-icons">
          {socials.map((item) => (
            <li className="social-icons" key={item.label}>
              <a
                className={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.label}
              >
                {item.icon}
              </a>
            </li>
          ))}
        </ul>
      </Container>
    </Container>
  );
}

export default Footer;
